import script from "./CulturePage.vue?vue&type=script&setup=true&lang=js"
export * from "./CulturePage.vue?vue&type=script&setup=true&lang=js"

import "./CulturePage.vue?vue&type=style&index=0&id=2086b292&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2086b292"]])

export default __exports__